import { createSelector } from 'reselect';

const globalState = (state) => state;

export const selectLoading = createSelector(
  globalState,
  (_globalState) => _globalState.loading,
);
